// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".adm-clinic-address[data-v-77e05fb2]{font-size:12px;max-width:240px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.adm-assign-row[data-v-77e05fb2]{display:flex;gap:10px}.adm-empty--tight[data-v-77e05fb2]{padding:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
